import { If } from "components";
import { useTranslation } from "react-i18next";
import { FormField } from "ui";

import { isRichTextEmpty } from "../../helpers";
import { UsageGuideVideoField } from "../UsageGuideVideoField";
import { UsageGuideReadOnlyViewProps } from "./UsageGuideReadOnlyView.types";

import "styles/quill-content.scss";

import styles from "./UsageGuideReadOnlyView.module.scss";

// Shows an inherited guide exactly as it is stored, with nothing editable.
// Anything writable here would be writing to the category's guide, which is the
// failure mode the whole two-scope design exists to prevent.
const UsageGuideReadOnlyView = ({ guide }: UsageGuideReadOnlyViewProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.readOnly}>
      <FormField label={t("How to use")}>
        <If condition={!isRichTextEmpty(guide.howToUseText)}>
          <div
            className="ql-content"
            dangerouslySetInnerHTML={{ __html: guide.howToUseText ?? "" }}
          />
        </If>

        <If condition={isRichTextEmpty(guide.howToUseText)}>
          <p className={styles.readOnly_empty}>{t("No text")}</p>
        </If>
      </FormField>

      <UsageGuideVideoField
        videoUrl={guide.videoUrl}
        isReadOnly
        onChange={() => undefined}
      />

      <FormField label={t("Frequently asked questions")}>
        <If condition={guide.faqItems.length === 0}>
          <p className={styles.readOnly_empty}>{t("No questions yet")}</p>
        </If>

        {guide.faqItems.map((faqItem) => (
          <div key={faqItem.id} className={styles.readOnly_faqItem}>
            <p className={styles.readOnly_faqQuestion}>
              {faqItem.question}

              {/* The admin endpoint returns disabled items too — say which
                  ones the customer and the assistant never see. */}
              <If condition={!faqItem.isEnabled}>
                <span className={styles.readOnly_hiddenTag}>{t("Hidden")}</span>
              </If>
            </p>
            <div
              className="ql-content"
              dangerouslySetInnerHTML={{ __html: faqItem.answer }}
            />
          </div>
        ))}
      </FormField>
    </div>
  );
};

export default UsageGuideReadOnlyView;
